export default __webpack_public_path__ + "static/ScalingWithIconCorrect-bc211fdcbf572c6d6721a0b95a4689f4.png";